import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { motion, AnimatePresence } from 'framer-motion';
import { ScrollToTopButton } from './ScrollToTopButton';

export function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-olo-dark">
      <Navbar />
      <AnimatePresence mode="popLayout">
        <motion.main 
          key={location.pathname}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.98 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="flex-grow pb-16 md:pb-0 w-full relative z-0"
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      <div className="pb-16 md:pb-0 relative z-10">
        <Footer />
      </div>
      <ScrollToTopButton />
    </div>
  );
}
